<script setup lang="ts">
import { AppText } from '@shared/ui/typography'
import { ModalDefault } from '@shared/ui/modals'
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import { useModalDuplicateAssessmentTemplate } from '../../../model/assessments/modal-duplicate-assessment-template.hook'

defineOptions({
  name: 'ModalDuplicateAssessmentTemplate',
})

const {
  refIsOpen,
  refIsLoading,
  refTemplate,
  closeModal,
  confirmDuplicate,
} = useModalDuplicateAssessmentTemplate()
</script>

<template>
  <ModalDefault
    :show="refIsOpen"
    :loading="refIsLoading"
    title="Duplicate assessment template"
    is-close-button
    @click:overlay="closeModal"
    @click:close="closeModal"
  >
    <AppText
      name="body2"
      color="slate-700"
    >
      Create an independent copy of "{{ refTemplate?.title }}" and open it for editing. The
      original stays untouched, so assessments already using it are unaffected.
    </AppText>

    <template #controls>
      <BtnPrimary
        text="Duplicate"
        color="emerald"
        :disabled="refIsLoading"
        @click="confirmDuplicate"
      />
      <BtnSecondary
        text="Cancel"
        @click="closeModal"
      />
    </template>
  </ModalDefault>
</template>
